// import logo from './logo.svg';
import './App.css';
import Login from './components/Login';
import AdminLogin from './components/AdminLogin';
import {
  Routes,
  Route,
  Outlet,
  useLocation,
} from 'react-router-dom';
import Dashboard from './components/Dashboard';
import UserLogin from './components/UserLogin';
import AddUserLogin from './components/AddUserLogin';
import { motion } from "framer-motion";
import Disclaimer from './components/Disclaimer';

const PageLayout = ({ children }) => children;

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
};

const pageTransition = {
  type: "tween",
  ease: "linear",
  duration: 0.5
};

const AnimationLayout = () => {
  const { pathname } = useLocation();
  return (
    <PageLayout>
      <motion.div
        key={pathname}
        initial="initial"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
      >
        <Outlet />
      </motion.div>
    </PageLayout>
  );
};

function App() {
  return (
    <div>
      <Routes>
        <Route element={<AnimationLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/userlogin' element={<UserLogin />} />
          <Route path='/userlogin/adduserlogin' element={<AddUserLogin />} />
          <Route path='/userlogin/adduserlogin/:id' element={<AddUserLogin />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
